import axiosConfig from "./axiosConfig";

const deleteSiteBillingConfigEntry = async (
  authToken: string,
  siteId: string,
  entryId: number
): Promise<void> => {
  await axiosConfig.delete(`/site/${siteId}/billing_config/${entryId}`, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
};

export default deleteSiteBillingConfigEntry;
